import { render, staticRenderFns } from "./FacebookImage.vue?vue&type=template&id=92d4a520&scoped=true"
import script from "./FacebookImage.vue?vue&type=script&lang=js"
export * from "./FacebookImage.vue?vue&type=script&lang=js"
import style0 from "./FacebookImage.vue?vue&type=style&index=0&id=92d4a520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d4a520",
  null
  
)

export default component.exports